//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';

type ReadProps = {
  mT?: string;
};

export const TonyWardSS23 = ({ mT }: ReadProps) => {
  return (
    <>
      <p className="topPargraph">
        The sun, a molten gold disc sinking towards the horizon, cast the world
        in a warm, orange glow. Cicadas buzzed their rhythmic song, a constant
        hum against the backdrop of gentle waves lapping the shore. On the
        pristine white sand, reclining on a chaise longue, lay Serena.
        <br />
        <br />
        She was the epitome of chic summer elegance. Her sundress, a confection
        of silk the color of spun sunshine, shimmered with every shift of her
        breath. Delicate gold sandals peeked out from beneath the flowing hem,
        their straps adorned with tiny seashells that caught the fading light. A
        wide-brimmed woven hat, its band adorned with a single, perfect orchid,
        shaded her face.
      </p>
      {/* <span style={{ fontSize: '13px', marginTop: mT }}>Haute Couture</span> */}
      <h3 style={{ marginTop: mT }}>TONY WARD</h3>
      <span style={{ fontSize: '13px' }}>Spring / Summer 23</span>
      <div>
        <video
          controls={true}
          controlsList="nodownload"
          playsInline
          muted
          autoPlay
          loop
          style={{ width: '100%', maxWidth: '100%' }}
        >
          <source
            src={
              '/media/tonyward_SS_23.mp4'
            }
            type="video/mp4"
          />
        </video>
      </div>
      <h4>SHE IS A LADY...</h4>
      {/* <h2>IN AN CHIC LAVISH SUMMER.</h2> */}
      <p className="topPargraph" style={{margin: 0}}>
        Serena wasn't just beautiful, she exuded an air of
        effortless luxury. A single diamond bracelet adorned her tanned wrist,
        catching the last rays of the sun and sending tiny rainbows dancing
        across the sand. Her lips, the color of a ripe summer peach, were curved
        in a gentle smile, her eyes closed, face turned towards the setting sun.
        <br />
        In the heart of a sun-drenched villa, where bougainvillea vines cascaded
        down ivory walls, Serena reveled in the languid embrace of summer. Her
        wardrobe, a symphony of opulence and ease, whispered secrets of
        far-flung destinations and sun-kissed adventures.
        <br />
        <br />
        As the first rays of dawn painted the sky in hues of apricot and rose,
        Lady Seraphina stepped into the courtyard. Her attire, a chic ensemble
        that blended timeless elegance with modern flair, was a testament to her
        discerning taste.
        <br />
        The Dress. A flowing sundress adorned with delicate lemon blossoms. Its
        neckline dipped gracefully, revealing just a hint of sun-kissed
        collarbones. The fabric, a whisper-light silk, danced around her ankles
        as she moved. Oversized sunglasses perched on her nose, shielding her
        eyes from the golden brilliance. A wide-brimmed straw hat, adorned with
        a silk ribbon, cast a shadow over her porcelain skin. And there, on her
        wrist, a gold bangle that tinkled like distant wind chimes. Barefoot,
        she wandered through the citrus grove, feeling the cool grass between
        her toes. But when the path turned rocky, she slipped into woven
        espadrilles, their soles echoing the rhythm of her heart.
        <br />
        <br />
        The Evening Extravaganza Under the Stars. As twilight painted the sky in
        indigo and amethyst, Serena transformed once more. The evening demanded
        drama—a lavish crescendo to the sun-drenched symphony.
      </p>
    </>
  );
};
